// [vendored] 원본: vsmr-common adapter-core proto/sim_stream.proto (v0.5.1)
// — 계약 변경은 adapter-core에서 하고 이 사본을 동기화한다.
//
// 공용 실시간 스트림 계약 (sim-stream v1) — 모든 어댑터가 이 스키마로 발행하고,
// 소비자(sim-stream-demux / sim-telemetry-sink / BFF / 웹)는 시뮬레이터 타입과
// 무관하게 소비한다. 타입 특이성(도메인 스냅샷 → 공용 계약 변환)은 어댑터
// 경계에서 끝낸다 — SM의 SimulatorSpec, 웹의 ParticipantKindSpec과 같은 원리.
// 설계: vsmr-common adapter-core/docs/sim-stream-contract-design.md
//
// 토픽 (key = task_id):
//   sim.simstate.v1   — 주기 상태 (기본 500ms)
//   sim.screenlog.v1  — 화면 로그 라인 (즉시, 발행 여부는 타입 선택)
//   sim.telemetry.v1  — 주기 텔레메트리 (기본 3000ms)

// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file stream/sim_stream.proto (package vsmr.stream.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * @generated from message vsmr.stream.v1.NamedValue
 */
export class NamedValue extends Message<NamedValue> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: double value = 2;
   */
  value = 0;

  /**
   * 표시용 (없으면 "")
   *
   * @generated from field: string unit = 3;
   */
  unit = "";

  constructor(data?: PartialMessage<NamedValue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.stream.v1.NamedValue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NamedValue {
    return new NamedValue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NamedValue {
    return new NamedValue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NamedValue {
    return new NamedValue().fromJsonString(jsonString, options);
  }

  static equals(a: NamedValue | PlainMessage<NamedValue> | undefined, b: NamedValue | PlainMessage<NamedValue> | undefined): boolean {
    return proto3.util.equals(NamedValue, a, b);
  }
}

/**
 * @generated from message vsmr.stream.v1.SimState
 */
export class SimState extends Message<SimState> {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId = "";

  /**
   * "mars" | "fmu" | ... (표시·필터용)
   *
   * @generated from field: string task_type = 2;
   */
  taskType = "";

  /**
   * 태스크별 단조 증가
   *
   * @generated from field: int64 seq = 3;
   */
  seq = protoInt64.zero;

  /**
   * wall-clock Unix epoch [ms]
   *
   * @generated from field: int64 ts_ms = 4;
   */
  tsMs = protoInt64.zero;

  /**
   * 시뮬레이션 문제 시간 [ms]
   *
   * @generated from field: int64 sim_time_ms = 5;
   */
  simTimeMs = protoInt64.zero;

  /**
   * 어댑터 태스크 상태의 대문자 — CREATED | RUNNING | PAUSED | COMPLETED | STOPPED | FAILED 중 그 어댑터가 쓰는 것
   *
   * @generated from field: string status = 6;
   */
  status = "";

  /**
   * 누적 스텝 수
   *
   * @generated from field: int64 iteration = 7;
   */
  iteration = protoInt64.zero;

  /**
   * 설정 배속 (0=최대, 1.0=실시간)
   *
   * @generated from field: float target_speed = 8;
   */
  targetSpeed = 0;

  /**
   * 실측 배속
   *
   * @generated from field: float actual_speed = 9;
   */
  actualSpeed = 0;

  /**
   * 추정 최대 배속 (미상이면 0)
   *
   * @generated from field: float max_speed = 10;
   */
  maxSpeed = 0;

  constructor(data?: PartialMessage<SimState>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.stream.v1.SimState";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "task_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "seq", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "ts_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "sim_time_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "iteration", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "target_speed", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "actual_speed", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "max_speed", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SimState {
    return new SimState().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SimState {
    return new SimState().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SimState {
    return new SimState().fromJsonString(jsonString, options);
  }

  static equals(a: SimState | PlainMessage<SimState> | undefined, b: SimState | PlainMessage<SimState> | undefined): boolean {
    return proto3.util.equals(SimState, a, b);
  }
}

/**
 * @generated from message vsmr.stream.v1.ScreenLogLine
 */
export class ScreenLogLine extends Message<ScreenLogLine> {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId = "";

  /**
   * @generated from field: string task_type = 2;
   */
  taskType = "";

  /**
   * @generated from field: int64 seq = 3;
   */
  seq = protoInt64.zero;

  /**
   * @generated from field: int64 ts_ms = 4;
   */
  tsMs = protoInt64.zero;

  /**
   * "stdout" | "stderr" | 엔진명 등
   *
   * @generated from field: string channel = 5;
   */
  channel = "";

  /**
   * @generated from field: string line = 6;
   */
  line = "";

  constructor(data?: PartialMessage<ScreenLogLine>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.stream.v1.ScreenLogLine";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "task_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "seq", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "ts_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "channel", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "line", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ScreenLogLine {
    return new ScreenLogLine().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ScreenLogLine {
    return new ScreenLogLine().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ScreenLogLine {
    return new ScreenLogLine().fromJsonString(jsonString, options);
  }

  static equals(a: ScreenLogLine | PlainMessage<ScreenLogLine> | undefined, b: ScreenLogLine | PlainMessage<ScreenLogLine> | undefined): boolean {
    return proto3.util.equals(ScreenLogLine, a, b);
  }
}

/**
 * @generated from message vsmr.stream.v1.Telemetry
 */
export class Telemetry extends Message<Telemetry> {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId = "";

  /**
   * @generated from field: string task_type = 2;
   */
  taskType = "";

  /**
   * @generated from field: int64 seq = 3;
   */
  seq = protoInt64.zero;

  /**
   * @generated from field: int64 ts_ms = 4;
   */
  tsMs = protoInt64.zero;

  /**
   * @generated from field: int64 sim_time_ms = 5;
   */
  simTimeMs = protoInt64.zero;

  /**
   * @generated from field: repeated vsmr.stream.v1.Telemetry.Group groups = 10;
   */
  groups: Telemetry_Group[] = [];

  constructor(data?: PartialMessage<Telemetry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.stream.v1.Telemetry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "task_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "seq", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "ts_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "sim_time_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "groups", kind: "message", T: Telemetry_Group, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Telemetry {
    return new Telemetry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Telemetry {
    return new Telemetry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Telemetry {
    return new Telemetry().fromJsonString(jsonString, options);
  }

  static equals(a: Telemetry | PlainMessage<Telemetry> | undefined, b: Telemetry | PlainMessage<Telemetry> | undefined): boolean {
    return proto3.util.equals(Telemetry, a, b);
  }
}

/**
 * 이름-값 샘플의 그룹. 객체 지향 도메인(MARS: volume/junction)은 그룹당
 * 객체 하나로, 평면 도메인(FMU: 변수 나열)은 kind=""/object_id=0 그룹
 * 하나로 매핑한다.
 *
 * @generated from message vsmr.stream.v1.Telemetry.Group
 */
export class Telemetry_Group extends Message<Telemetry_Group> {
  /**
   * "volume" | "junction" | "" 등 — 소비자 태깅용
   *
   * @generated from field: string kind = 1;
   */
  kind = "";

  /**
   * 그룹핑 없으면 0
   *
   * @generated from field: int64 object_id = 2;
   */
  objectId = protoInt64.zero;

  /**
   * @generated from field: repeated vsmr.stream.v1.NamedValue samples = 3;
   */
  samples: NamedValue[] = [];

  constructor(data?: PartialMessage<Telemetry_Group>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.stream.v1.Telemetry.Group";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "object_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "samples", kind: "message", T: NamedValue, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Telemetry_Group {
    return new Telemetry_Group().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Telemetry_Group {
    return new Telemetry_Group().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Telemetry_Group {
    return new Telemetry_Group().fromJsonString(jsonString, options);
  }

  static equals(a: Telemetry_Group | PlainMessage<Telemetry_Group> | undefined, b: Telemetry_Group | PlainMessage<Telemetry_Group> | undefined): boolean {
    return proto3.util.equals(Telemetry_Group, a, b);
  }
}

